
import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

const settings = (itemsOnDesktop, itemsOnBigDesktop) => ({
  // could be customizable on BE
 autoplaySpeed: 1000,
 arrows: true,
 dots: true,
 infinite: true,
 swipeToSlide: true,
 slidesToShow: itemsOnBigDesktop || 5,
 speed: 1000,
 responsive: [
   {
     breakpoint: 1800,
     settings: {
       slidesToShow: itemsOnDesktop || 4,
     }
   },
   {
     breakpoint: 980,
     settings: {
       slidesToShow: 3,
     }
   },
   {
     breakpoint: 640,
     settings: {
       slidesToShow: 2,
     }
   },
   {
     breakpoint: 480,
     settings: {
       slidesToShow: 1,
     }
   }
 ]
});

class ProductsCarousel extends React.PureComponent {
  constructor(props) {
      super(props);
      this.ref = React.createRef();
  }

  componentDidMount() {
    window.__litium.loadBuyButtons(this.ref.current);
    window.__litium.loadSalesInput(this.ref.current);
    window.__litium.loadWishlistSelect();
    window.__litium.loadWishlistFavorites();
  }

  render() {
    const { title, layout, carouselId } = this.props;
    // TODO: titleToId replace with some block/component ID
    const titleToId = title.replaceAll(/[\W_0-9]/g, '');
    const dataSlider = window.__litium.productsCarousel[titleToId];
    const itemsOnDesktop = layout === 'nextToImage' ? 3 : undefined;
    const itemsOnBigDesktop = layout === 'nextToImage' ? 3 : undefined;
    
    return (
      <div className="product-carousel-block__wrapper">
        <div className="row">
          <div className="columns small-12 product-carousel-block__info">
            <h3 className="product-carousel-block__header">{title}</h3>
          </div>
          <div
            className={`columns small-12 product-carousel-block ${
              layout ? "product-carousel-block--" + layout : ""
            }`}
            ref={this.ref}
            data-list-id={carouselId}
          >
            <Slider {...settings(itemsOnDesktop, itemsOnBigDesktop)}> 
                
            {dataSlider && dataSlider.map((i, index) => {
              return (
                <div key={`figure${index}`} dangerouslySetInnerHTML={{ __html: i }} ></div>)
            })}
            </Slider>
          </div>
        </div>
      </div>
    )
  }
};
export default ProductsCarousel;
